import { addLocaleData } from 'react-intl';
import cs from 'react-intl/locale-data/cs';
import da from 'react-intl/locale-data/da';
import de from 'react-intl/locale-data/de';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import et from 'react-intl/locale-data/et';
import fr from 'react-intl/locale-data/fr';
import it from 'react-intl/locale-data/it';
import lt from 'react-intl/locale-data/lt';
import lv from 'react-intl/locale-data/lv';
import nl from 'react-intl/locale-data/nl';
import pl from 'react-intl/locale-data/pl';
import pt from 'react-intl/locale-data/pt';
import ro from 'react-intl/locale-data/ro';
import sk from 'react-intl/locale-data/sk';

import {
    defaultTo,
    flow,
    has,
    head,
    map,
    split,
    zipObject,
} from 'lodash/fp';

addLocaleData([
    ...cs,
    ...da,
    ...de,
    ...en,
    ...es,
    ...et,
    ...fr,
    ...it,
    ...lt,
    ...lv,
    ...nl,
    ...pl,
    ...pt,
    ...ro,
    ...sk,
]);

export const DEFAULT_LOCALE = 'en-GB';

const nonIsoLocales = [
    'cs-CZ',
    'da-DK',
    'de-DE',
    'en-GB',
    'en-US',
    'es-ES',
    'et-EE',
    'fr-FR',
    'it-IT',
    'lv-LV',
    'lt-LT',
    'nl-NL',
    'pl-PL',
    'pt-PT',
    'ro-RO',
    'sk-SK',
];

const baseTranslations = flow(
    // eslint-disable-next-line global-require
    map(locale => require(`./lang/appnavigator_${locale}.json`)),
    zipObject(nonIsoLocales)
)(nonIsoLocales);

export const translations = {
    ...baseTranslations,
    de: baseTranslations['de-DE'],
    da: baseTranslations['da-DK'],
    en: baseTranslations['en-GB'],
    es: baseTranslations['es-ES'],
    et: baseTranslations['et-EE'],
    fr: baseTranslations['fr-FR'],
    it: baseTranslations['it-IT'],
    lt: baseTranslations['lt-LT'],
    lv: baseTranslations['lv-LV'],
    nl: baseTranslations['nl-NL'],
    pl: baseTranslations['pl-PL'],
    pt: baseTranslations['pl-PT'],
    ro: baseTranslations['ro-RO'],
    sk: baseTranslations['sk-SK'],
};

if (!has(DEFAULT_LOCALE, translations)) {
    // eslint-disable-next-line no-console
    console.warn(
        `The configured default locale "${DEFAULT_LOCALE}" is not present.`
    );
}

const extractLanguage = flow(
    defaultTo(DEFAULT_LOCALE),
    split('-'),
    head
);

export const configureLocale = (navigator, lookup) => {

    const getSupportedLocaleFromTranslations = languageData => flow(
        locale => has(locale, languageData) ? locale : extractLanguage(locale),
        locale => has(locale, languageData) ? locale : navigator.language,
        locale => has(locale, languageData) ? locale : DEFAULT_LOCALE
    );

    return {
        getLanguageData: locale => lookup[locale],
        getSupportedLocale: getSupportedLocaleFromTranslations(lookup),
    };
};

export const { getLanguageData, getSupportedLocale } = configureLocale(navigator, translations);
